.layout {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    margin-left: var(--spacing-04);
  }
}
